export const markSelectedDate = (
  dateInfo: Map<string, any>,
  selectedDate: string
) => {
  if (selectedDate) {
    if (dateInfo.has(selectedDate)) {
      const existingValue = dateInfo.get(selectedDate);
      dateInfo.set(selectedDate, { ...existingValue, selected: true });
    } else {
      dateInfo.set(selectedDate, { selected: true });
    }
  }
  return dateInfo;
};
